<template>
  <input
    class="md-input"
    :type="type"
    :name="name"
    v-model="inputValue"
    :disabled="disabled || null"
    :required="required"
    :placeholder="placeholder"
    :maxlength="maxlength"
    :readonly="readonly"
    v-on:keypress="isLetter($event)"
    @change="onChange"
    @focus="onFocus"
    @blur="onBlur"
    step=".01"
    @wheel="handleOnWheel"
    autocomplete="off"
    autocorrect="off"
    spellcheck="false"
  />
</template>

<script>
import { defineComponent } from 'vue';
import common from './common';

export default defineComponent({
  name: 'md-input',
  props: {
    type: {
      type: String,
      default: 'text',
    },
    onlyRegularCharacters: {
      type: Boolean,
      default: false,
    },
  },
  mixins: [common],
  watch: {
    inputValue(newValue, oldValue) {
      const isAlphaNumeric = /^[A-Za-z0-9 ]*$/.test(newValue);
      if (!(!this.onlyRegularCharacters || (isAlphaNumeric && newValue.split(' ').length <= 4))) {
        this.inputValue = oldValue || '';
      }
      if (this.type === 'number') {
        this.onUpdateValue(this.inputValue);
      } else {
        this.onUpdateValue(this.inputValue || '');
      }
    },
  },
  methods: {
    isLetter(e) {
      let char = String.fromCharCode(e.keyCode);
      if (!this.onlyRegularCharacters || /^[A-Za-z0-9 ]+$/.test(char)) return true;
      else e.preventDefault();
    },
    handleOnWheel(e) {
      e.target.blur();
    },
  },
});
</script>
